<template>
    <div class="task-message">
        <van-overlay className="taskLoading" :show="loading" :style="countTaskReq > 1 ? '' : 'background-color: transparent'">
            <div class="wrapper" @click.stop>
                <van-loading color="#0094ff" vertical>加载中...</van-loading>
            </div>
        </van-overlay>
        <van-skeleton title avatar :row="4" :loading="loading && countTaskReq < 2" style="margin-top: 32px">
            <div class="message-content">
                <div class="info">
                    <div class="title">
                        <div>参与人邀请</div>
                        <van-button class="btn" :class="messageInfo.WorkStatus === 102 ? 'notsent' : 'sented'" round type="primary">{{ getStatus(messageInfo.WorkStatus) }}</van-button>
                    </div>
                    <van-divider class="divider" />
                    <div class="content">
                        <div class="info">
                            <van-image class="image" round fit="cover" lazy-load :src="messageInfo.UserIcon" />
                            <div class="name">{{ messageInfo.Creator }}</div>
                        </div>
                        <div class="text">{{ messageInfo.Tip }}</div>
                    </div>
                </div>
                <div class="card">
                    <div class="content">
                        <div class="item">
                            <div class="label">任务名称</div>
                            <div class="value">
                                {{ messageInfo.TaskName && messageInfo.TaskName !== '' ? messageInfo.TaskName : '暂无描述' }}
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">任务描述</div>
                            <div class="value">{{ messageInfo.TaskRemark && messageInfo.TaskRemark !== '' ? messageInfo.TaskRemark : '暂无描述' }}</div>
                        </div>
                        <div class="item">
                            <div class="label">任务时间</div>
                            <div class="value">【{{ formatDate(messageInfo.PlannedStartTime, 1) }}】 - 【{{ formatDate(messageInfo.PlannedFinishTime, 1) }}】</div>
                        </div>
                        <div class="item">
                            <div class="label">计划工时</div>
                            <div class="value">{{ messageInfo.ExpectedManHour }}</div>
                        </div>
                        <div class="item">
                            <div class="label">任务来源</div>
                            <div class="value">{{ messageInfo.ProjectName }}</div>
                        </div>
                        <div class="item">
                            <div class="label">发布时间</div>
                            <div class="value">{{ formatDate(messageInfo.CreateTime) }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot" v-if="messageInfo.WorkStatus === 101">
                <van-button class="btn jj" type="default" round size="large" @click="click(0)">拒 绝</van-button>
                <van-button class="btn" type="primary" round size="large" @click="click(1)">确认接收</van-button>
            </div>
        </van-skeleton>
        <van-action-sheet v-model:show="show">
            <div class="task-sheet-title">
                <div class="title">填写拒绝原因</div>
                <div class="btns">
                    <div class="btn cancel" @click="cancle">取消</div>
                    <div class="btn confirm" @click="confirm" v-if="(rejectRemark || '').trim().length">确认</div>
                </div>
            </div>
            <van-divider class="divider" style="margin: 0" />
            <div class="task-sheet-content">
                <van-field ref="messageInput" v-model="rejectRemark" rows="8" autosize type="textarea" maxlength="100" placeholder="请输入拒绝原因" show-word-limit />
            </div>
        </van-action-sheet>
    </div>
</template>

<script lang="ts">
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import moment from 'moment';

export default {
    setup() {
        const store = useStore();
        const task = store.state.task;
        const route = useRoute();
        const router = useRouter();
        const loginUser = JSON.parse(localStorage.loginUser);
        const userGuid = loginUser.UserGUID;
        const taskGuid = route.params.TaskGUID;
        const show = ref(false);
        const rejectRemark = ref('');
        const countTaskReq = ref(0);
        const messageInput = ref();

        const loading = computed(() => task.loading);
        const loadingRecieve = computed(() => task.loadingRecieve);
        const loadingReject = computed(() => task.loadingReject);
        const messageInfo = computed(() => (task.infos.length > 0 ? task.infos[0] : {}));

        const getTask = () => {
            countTaskReq.value++;
            return store.dispatch('task/CENTER_GET_TASK', { userGuid, taskGuid });
        };

        const getStatus = (status: number) => {
            switch (status) {
                case 101:
                    return '待接收';
                case 102:
                    return '已拒绝';
                default:
                    return '已接收';
            }
        };

        const formatDate = (date: string, type: number) => {
            if (!date || date === '') return '- -';
            return type === 1 ? moment(date).format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD HH:mm:ss');
        };

        const click = (isReceive: number) => {
            if (isReceive === 0) {
                show.value = true;
            }
            if (isReceive === 1) {
                store.dispatch('task/CENTER_RECEIVE_TASK', { userGuid, taskGuid, isReceive });
            }
        };
        const cancle = () => (show.value = false);
        const confirm = () => {
            show.value = false;
            store.dispatch('task/CENTER_REJECT_TASK', { userGuid, taskGuid, isReceive: 0, rejectRemark: rejectRemark.value });
        };

        // 监听结果
        watch(
            () => task.loading,
            (val: boolean, old: boolean) => {
                if (val === false && old === true) {
                    if (task.status === 0)
                        router.push({
                            name: 'notfound',
                        });
                }
            },
        );
        watch(
            () => task.loadingRecieve,
            (val: boolean, old: boolean) => {
                if (val === false && old === true) getTask();
            },
        );
        watch(
            () => task.loadingReject,
            (val: boolean, old: boolean) => {
                if (val === false && old === true) getTask();
            },
        );

        onMounted(() => {
            getTask().then(() => {
                let { refuse } = route.query;
                console.log('route.params  ', route.query);
                console.log('refuse ', refuse);
                console.log('messageInfo.value.WorkStatus ', messageInfo.value.WorkStatus);
                if (messageInfo.value.WorkStatus === 101) {
                    if (refuse === '1') {
                        show.value = true;
                        nextTick(() => {
                            messageInput.value.focus();
                        });
                    }
                }
            });
        });

        return {
            countTaskReq,
            loading,
            messageInfo,
            show,
            rejectRemark,
            getStatus,
            click,
            formatDate,
            cancle,
            confirm,
            loadingRecieve,
            loadingReject,
            messageInput,
        };
    },
};
</script>

<style lang="less" scoped>
.task-message {
    height: 100%;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .message-content {
        margin-bottom: 80px;
    }
    .info {
        padding: 0 16px 16px 16px;
        background: #fff;
        .title {
            display: flex;
            height: 48px;
            font-size: 18px;
            font-weight: 500;
            color: #333;
            line-height: 48px;
            .btn {
                width: 52px;
                font-size: 10px;
                height: 24px;
                margin: auto 0;
                padding: 0;
                margin-left: 12px !important;
                line-height: 24px;
            }
            .notsent {
                border-color: rgba(245, 108, 108, 0);
                background: rgba(245, 108, 108, 0.1);
                color: #f56c6c;
            }
            .sented {
                border-color: rgba(46, 135, 251, 0);
                background: rgba(46, 135, 251, 0.1);
                color: #2e87fb;
            }
        }
        .divider {
            margin: 0;
            height: 1px;
            font-weight: 500;
            background: #ebedf0;
        }
        .content {
            font-size: 16px;
            font-weight: 400;
            .info {
                display: flex;
                padding: 12px 0;
                .image {
                    width: 40px;
                    height: 40px;
                }
                .name {
                    color: #333;
                    line-height: 40px;
                    margin-left: 8px;
                }
            }
            .text {
                color: #666;
            }
        }
    }
    .card {
        margin-top: 10px;
        padding: 12px 16px;
        background: #fff;
        .title {
            font-size: 16px;
            font-weight: 400;
            color: #323233;
        }
        .content {
            .item {
                display: flex;
                flex-direction: row;
                margin-top: 12px;
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
                .label {
                    width: 60px;
                    color: #969799;
                    margin-right: 12px;
                }
                .value {
                    flex: 1;
                    color: #646566;
                }
            }
        }
    }
}
.foot {
    display: flex;
    justify-content: space-between;
    padding: 16px;
    position: fixed;
    bottom: 0;
    background: #fff;
    width: 92%;
    .btn {
        width: 166px;
        height: 44px;
    }
    .btn.jj {
        color: #ff7875;
    }
}
.taskLoading {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    .wrapper {
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>

<style lang="less">
.task-sheet-title {
    height: 44px;
    font-size: 16px;

    line-height: 44px;
    text-align: center;
    position: relative;
    .title {
        font-weight: 500;
    }

    .btns {
        top: 0;
        left: 0;
        position: absolute;
        display: flex;
        justify-content: space-between;
        width: 100%;
        .btn {
            font-size: 14px;
            padding: 0 16px;
        }

        .cancel {
            color: #969799;
        }
        .confirm {
            color: #2e87fb;
        }
    }
}
</style>
